(function () {
  const path = window.location.pathname;
  const onCheckoutPage = path.includes("/checkouts") || path.includes("/checkout");
  const onCartPage = path.includes("/cart");

  // Only run on cart/checkout pages
  if (!onCheckoutPage && !onCartPage) return;

  // Check if URL has discount parameter
  const urlHasDiscount = window.location.search.includes("discount=");
  if (!urlHasDiscount) return;

  // Check login state
  const isLoggedIn = !!window.customerLoggedIn;

  // 🔒 Critical: If user logs in mid-checkout, revoke discount claim
  if (isLoggedIn) {
    sessionStorage.removeItem("dw_clicked_discount");
  }

  // Extract discount code from URL
  const urlParams = new URLSearchParams(window.location.search);
  const discountCode = urlParams.get("discount");

  // If logged-in user tries to use WELCOME10 → block it
  if (isLoggedIn && discountCode === "WELCOME10") {
    console.log("⛔ Logged-in user attempted to use WELCOME10 - blocking");

    fetch("/discount/WELCOME10", {
      method: "DELETE",
      credentials: "include",
    }).finally(() => {
      const cleanUrl = window.location.href.replace(/(\?|&)discount=[^&]+/, "");
      if (cleanUrl !== window.location.href) {
        window.location.replace(cleanUrl);
      }
    });

    return;
  }

  // For logged-out users check if they clicked claim
  if (!isLoggedIn) {
    const clicked = sessionStorage.getItem("dw_clicked_discount");

    // If user clicked claim → allow discount
    if (clicked && discountCode === "WELCOME10") {
      console.log("✅ Guest user claimed WELCOME10 discount");
      return;
    }

    // If they didn't click claim → strip discount
    if (!clicked && discountCode === "WELCOME10") {
      console.log("⚠️ WELCOME10 in URL but not claimed - removing");

      fetch("/discount/WELCOME10", {
        method: "DELETE",
        credentials: "include",
      }).finally(() => {
        const cleanUrl = window.location.href.replace(/(\?|&)discount=[^&]+/, "");
        if (cleanUrl !== window.location.href) {
          window.location.replace(cleanUrl);
        }
      });
    }
  }
})();
